import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchReviewByRequest, fetchApprovedReviews, createReview } from './api';

export function useReviewByRequest(requestId: string, enabled = true) {
  return useQuery({
    queryKey: ['reviews', requestId],
    queryFn: () => fetchReviewByRequest(requestId),
    enabled: enabled && !!requestId,
  });
}

export function useApprovedReviews(limit = 3) {
  return useQuery({
    queryKey: ['reviews', 'approved', limit],
    queryFn: () => fetchApprovedReviews(limit),
  });
}

export function useCreateReview() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({
      requestId,
      revieweeId,
      rating,
      comment,
    }: {
      requestId: string;
      revieweeId: string;
      rating: number;
      comment?: string;
    }) => createReview(requestId, { revieweeId, rating, comment }),
    onSuccess: (_data, { requestId }) => {
      qc.invalidateQueries({ queryKey: ['reviews', requestId] });
    },
  });
}
